// extracted by mini-css-extract-plugin
export default {"customSelect":"style_customSelect__7I7Zo","viewIcon":"style_viewIcon__JWML9","tableRows":"style_tableRows__jm0RQ","tableText":"style_tableText__ZztJp"};